import React, { memo } from 'react'
import tw from 'twin.macro'
import { ChevronRightMinor } from '@shopify/polaris-icons'
import { Typography } from '@mui/material'
import { colors } from 'src/theme'

interface Props {
  icon: React.ReactNode
  title: string
  subtitle?: string
  isSelected?: boolean
  onClick?: () => void
  dataTestId?: string
}

const SettingsSidebarItemComponent = ({
  icon,
  title,
  subtitle,
  isSelected,
  onClick,
  dataTestId,
}: Props) => {
  return (
    <div
      data-testid={dataTestId}
      css={[
        tw`bg-white rounded-lg p-4 flex flex-row items-center justify-between cursor-pointer transition-colors hover:bg-[#F6F6F6]`,
        isSelected && tw`bg-[#F6F6F6]`,
        !isSelected && tw`border-0 border-b border-t border-solid border-[#EDEDED] rounded-none`,
      ]}
      onClick={onClick}
      role="button"
      tabIndex={0}
      aria-label={`Select ${title}`}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClick?.()
        }
      }}
    >
      <div css={tw`flex flex-row items-center flex-1`}>
        {icon && <div css={tw`p-4`}>{icon}</div>}
        <div css={tw`flex-1`}>
          <Typography variant="h6" css={tw`mb-0.5 font-semibold`}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color={colors.SHADES_GREY_400}>
              {subtitle}
            </Typography>
          )}
        </div>
      </div>
      <ChevronRightMinor css={tw`ml-2`} width={20} height={20} fill={colors.SHADES_GREY_300} />
    </div>
  )
}

export const SettingsSidebarItem = memo(SettingsSidebarItemComponent)
